import gql from 'graphql-tag'

export default gql`
  mutation createUsersFileExport {
    createUsersFileExport
  }
`
